require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-country-partnership-framework.json") })
        }
      }, "path---en-us-update-country-partnership-framework");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-country-partnership-framework!./.cache/json/en-us-update-country-partnership-framework.json
// module id = 649
// module chunks = 231608221292675